import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import LoginProtected from "./LoginProtected.js";
import Protected from "./Protected.js";
import Orders from "../Pages/Orders/Orders";
import FulFilledOrder from "../Pages/Orders/FulfilledOrder";
import DashboardPage from "../Pages/Dashboard/Dashboard";
import OrderDetailsPage from "../Pages/OrderDetails";
import PageNotFound from "./PageNotFound";
import Login from "../Pages/Login";
import Register from "../Pages/Register";
import ForgotPassword from "../Pages/Forgotpassword";
import Sidebar from "./Sidebar/Sidebar";
import Topbar from "./Topbar/Topbar";
import Profile from "../Pages/Profile";
import { useEffect, useState } from "react";
import Enterprise from "../Pages/Enterprise.js";
import EnterpriseDetails from "../Pages/Enterprise/EnterpriseDetails.jsx";
import Players from "../Pages/Players.js";
import NotificationSender from "../Pages/notificationAPN.js";
import NotificationLogs from "../Pages/notificationLogs.js";
import AppRelease from "../Pages/App-Release/AppRelease.jsx";

const DashboardRoutes = () => {
  const [data, setData] = useState(false);
  const [lang, setLang] = useState("en");
  const location = useLocation();
  let loggedInUser = localStorage.getItem("LoggedIn");

  const isSuperAdmin = localStorage.getItem("super_admin") === "true";

  const handleChildData = (data) => {
    setData(data);
    // console.log("Data received from child:", data);
    // Process the data in the parent component
  };
  const handlelang = (data) => {
    setLang(data);
  };

  const navigate = useNavigate();
  return (
    <>
      <div id="wrapper">
        {location.pathname == "/" || loggedInUser == null ? (
          ""
        ) : (
          <Sidebar
            message={data}
            onDataUpdate={handleChildData}
            Language={lang}
          />
        )}
        <div id="content-wrapper" className=" d-flex flex-column">
          {location.pathname == "/" || loggedInUser == null ? (
            ""
          ) : (
            <Topbar
              message={data}
              Language={lang}
              onLangUpdate={handlelang}
              onDataUpdate={handleChildData}
            />
          )}

          <Routes>
            {loggedInUser ? (
              <Route
                path="/"
                element={
                  <LoginProtected>
                    <Login Language={lang} />
                  </LoginProtected>
                }
              />
            ) : (
              <Route path="*" element={<Login />} />
            )}
            {loggedInUser ? (
              <Route
                path="/register"
                element={
                  <LoginProtected>
                    <Register Language={lang} />
                  </LoginProtected>
                }
              />
            ) : (
              <Route path="*" element={<Login />} />
            )}
            {loggedInUser ? (
              <Route
                path="/forgotpassword"
                element={
                  <LoginProtected>
                    <ForgotPassword Language={lang} />
                  </LoginProtected>
                }
              />
            ) : (
              <Route path="*" element={<Login />} />
            )}
            {loggedInUser ? (
              <Route
                path="/orders"
                element={
                  <Protected>
                    <Orders Language={lang} />
                  </Protected>
                }
              />
            ) : (
              <Route path="*" element={<Login />} />
            )}
            {loggedInUser ? (
              <Route
                path="/order/:id"
                element={
                  <Protected>
                    <OrderDetailsPage Language={lang} />
                  </Protected>
                }
              />
            ) : (
              <Route path="*" element={<Login />} />
            )}
            {loggedInUser ? (
              <Route
                path="/dashboard"
                element={
                  <Protected>
                    <DashboardPage Language={lang} />
                  </Protected>
                }
              />
            ) : (
              <Route path="*" element={<Login />} />
            )}
            {loggedInUser ? (
              <Route
                path="/profile"
                element={
                  <Protected>
                    <Profile Language={lang} />
                  </Protected>
                }
              />
            ) : (
              <Route path="*" element={<Login />} />
            )}
            {loggedInUser ? (
              <Route
                path="/notification"
                element={
                  <Protected>
                    <NotificationSender Language={lang} />
                  </Protected>
                }
              />
            ) : (
              <Route path="*" element={<Login />} />
            )}

            {loggedInUser ? (
              <Route
                path="/notification-logs"
                element={
                  <Protected>
                    <NotificationLogs Language={lang} />
                  </Protected>
                }
              />
            ) : (
              <Route path="*" element={<Login />} />
            )}

            {loggedInUser ? (
              <Route
                path="/orders/:status"
                element={
                  <Protected>
                    <FulFilledOrder Language={lang} />
                  </Protected>
                }
              />
            ) : (
              <Route path="*" element={<Login />} />
            )}
            {loggedInUser ? (
              <Route
                path="/app-release"
                element={
                  <Protected>
                    <AppRelease Language={lang} />
                  </Protected>
                }
              />
            ) : (
              <Route path="*" element={<Login />} />
            )}

            {isSuperAdmin && (
              <Route
                path="/enterprise"
                element={
                  <Protected>
                    <Enterprise Language={lang} />
                  </Protected>
                }
              />
            )}
            {isSuperAdmin && (
              <Route
                path="/enterprise/:id"
                element={
                  <Protected>
                    <EnterpriseDetails Language={lang} />
                  </Protected>
                }
              />
            )}
            {isSuperAdmin && (
              <Route
                path="/enterprise/:enterpriseId/players"
                element={
                  <Protected>
                    <Players Language={lang} />
                  </Protected>
                }
              />
            )}
            {loggedInUser ? (
              <Route path="*" element={<PageNotFound Language={lang} />} />
            ) : (
              <Route path="*" element={<Login />} />
            )}
          </Routes>
        </div>
      </div>
    </>
  );
};

export default DashboardRoutes;
